export default __webpack_public_path__ + "locales/cs/Payments.json?hash=e6ff461f24a8470cfac8e7d9900bceb2";